import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useFetchPriceSuggestionItemPrices } from '@retail/price-suggestion/data-access';
import { usePriceSuggestionTFunction } from '@retail/price-suggestion/i18n';
import { PriceSuggestionPrice } from '@retail/price-suggestion/types';
import { PriceSuggestionType } from '@retail/products/types';
import { useCallback } from 'react';
import { EditPriceSuggestionConditionDialog } from './EditPriceSuggestionConditionDialog';
import { ConditionBinding } from '@retail/calculus/types';

interface Props {
  currentPriority: PriceSuggestionType[];
  currentValidFrom?: Date;
  supplierNumber: number;
  itemName: string;
  mgItemNumber: number;
  onClose: () => void;
}

export function EditItemPriceSuggestionConditionDialog({
  currentPriority,
  currentValidFrom,
  supplierNumber,
  itemName,
  mgItemNumber,
  onClose,
}: Props) {
  const t = usePriceSuggestionTFunction();
  const { assortmentId } = useSelectedOrgUnit();

  const { data: itemLevelPriceSuggestionDTO = [] } = useFetchPriceSuggestionItemPrices({
    assortmentId,
    mgSupplierId: supplierNumber,
    mgItemNumber,
  });
  const itemLevelPriceSuggestions = itemLevelPriceSuggestionDTO?.map(PriceSuggestionPrice.fromDto);

  const getItemPrice = useCallback(
    (priceType: PriceSuggestionType) => {
      const priceSuggestion = itemLevelPriceSuggestions.find(
        (priceSuggestion) => priceSuggestion.priceSuggestionType === priceType
      );
      return t('priceSuggestion.pricePerUnit', {
        price: priceSuggestion?.price,
        unit: priceSuggestion?.unit.description,
      });
    },

    [itemLevelPriceSuggestions, t]
  );

  return (
    <EditPriceSuggestionConditionDialog
      open
      bindingName={itemName}
      currentPriority={currentPriority}
      priceSuggestionTypes={itemLevelPriceSuggestions.map((ps) => ps.priceSuggestionType)}
      conditionBinding={
        { legacySupplierItem: { mgItemNumber, supplierNumber } } as ConditionBinding
      }
      currentValidFrom={currentValidFrom}
      getCustomPriceSuggestionLabel={getItemPrice}
      onClose={onClose}
    />
  );
}
